export default __webpack_public_path__ + "static/media/visa.303120b3.svg";